const carouselItems = [
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20warm%20toned%20editorial%20illustration%20mysterious%20atmosphere%20with%20crimson%20and%20gold%20accents%20stylized%20abstract%20composition%20representing%20entertainment%20scandal%20and%20hidden%20truth%20cinematic%20lighting%20rich%20textures%20sophisticated%20art%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
    title: '某顶流塌房全纪录',
    desc: '从代言解约到粉丝脱粉，深度复盘顶流艺人三个月内从巅峰跌落的完整时间线。',
    tag: '热度爆表',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20art%20with%20warm%20golden%20and%20deep%20red%20palette%20abstract%20figures%20in%20dramatic%20pose%20mysterious%20spotlight%20illumination%20representing%20internet%20celebrity%20scandal%20exposure%20sophisticated%20illustration%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
    title: '网红圈连环爆料',
    desc: '多位头部网红接连被曝偷税漏税、虚假人设，一场席卷直播圈的地震正在蔓延。',
    tag: '持续追踪',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20editorial%20illustration%20with%20warm%20amber%20and%20crimson%20hues%20abstract%20stage%20setting%20with%20hidden%20figures%20cinematic%20lighting%20representing%20reality%20show%20secrets%20and%20behind%20scenes%20truth%20sophisticated%20art%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    title: '综艺黑幕大起底',
    desc: '前综艺编导匿名投稿，揭开选秀节目剪辑操控、剧本内定和选手不公平待遇的内幕。',
    tag: '独家深扒',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20composition%20with%20warm%20red%20and%20gold%20gradients%20mysterious%20crowd%20scene%20in%20abstract%20form%20dramatic%20backstage%20atmosphere%20representing%20music%20festival%20secrets%20and%20hidden%20truths%20sophisticated%20modern%20illustration&width=800&height=500&seq=carousel-04&orientation=landscape',
    title: '音乐节后台秘辛',
    desc: '当红歌手被曝假唱、主办方克扣艺人出场费，音乐节行业的真实生态令人震惊。',
    tag: '最新爆料',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">近期最值得关注的深度报道</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block text-xs font-medium px-2 py-1 rounded mb-2 ${item.tagColor}`}>
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}